module.exports = __webpack_public_path__ + "img/puroak.icon.pefc.asset.99502fcc.svg";